/**
 * Invoice Templates Registry
 * 
 * Provides dynamic discovery of built-in and customer-customized invoice print templates.
 */

import { customInvoiceTemplates } from "../../../custom/templates/customTemplates.js";

export const BUILT_IN_TEMPLATES = [
  {
    id: "modern-tax",
    name: "Modern Tax Invoice",
    desc: "Corporate tax layout with item tax breakdown"
  },
  {
    id: "paper-ledger",
    name: "Physical Paper Bill",
    desc: "Authentic double-entry style traditional paper receipt"
  },
  {
    id: "compact",
    name: "Compact Slip",
    desc: "Condensed single-page format"
  }
];

/**
 * Returns all available templates (built-in + customer-customized)
 */
export function getAllInvoiceTemplates() {
  const customList = Array.isArray(customInvoiceTemplates) ? customInvoiceTemplates : [];
  return [...BUILT_IN_TEMPLATES, ...customList];
}

/**
 * Find template metadata by id
 */
export function getInvoiceTemplateById(id) {
  const all = getAllInvoiceTemplates();
  return all.find(t => t.id === id) || all[0];
}

export default getAllInvoiceTemplates;
